<template>
	<div class="setting-box">
		<el-card class="card" shadow="never">
			<span class="flex headder">
				<el-button icon="el-icon-arrow-left" @click="backList">返回</el-button><span class="title font-16" style="line-height: 40px">{{edit?'编辑':'新建'}}方案</span>
				<el-button size="medium" type="success" @click="saveCase"><span class="iconfont icon-save mr-xs"></span>保存</el-button>
			</span>
			<el-form ref="caseForm" class="pl-120 mt-lg mb" label-position="left" label-width="120px" :model="formData" :rules="caseRules">
				<el-form-item prop="title" label="方案名称">
					<el-input v-model="formData.title" style="width: 300px"></el-input>
				</el-form-item>
				<div class="setting-header font-16">{{ '控件设置' }}</div>
				<div class="setting-content pr-120 mt">
					<div class="empty" v-if="!editing">
						<!-- <img src="@/assets/logo.png" /> -->
						<p>还没有可以编辑的内容组件</p>
					</div>
					<div v-else :is="editing.setting.component" :editing="editing" @update="update"></div>
				</div>
			</el-form>
		</el-card>
	</div>
</template>
<script>
import { array2Object } from '@/utils/common'
export default {
	name: 'SettingBox',
	props: {
		editing: [Object, Boolean],
		value: {
			type: [Object, String],
			default: 0
		},
		formData: Object,
		designs: Array,
		is_default: Number,
		edit: {
			type: Boolean
		}
	},
	computed: {
		title: {
			get () {
				return this.value ? this.value : null
			},
			set (val) {
				this.$emit('input', val ? val : null)
			}
		},
		designsObj () {
			return array2Object(this.designs, 'id')
		}
	},
	data () {
		return {
			caseRules: {
				title: { required: true, message: '请输入方案名称', trigger: 'blur' }
			},
			checkArr: []
		}
	},
	methods: {
		saveCase () {
			this.$refs['caseForm'].validate(valid => {
				if (valid) {
					this.checkArr.forEach(item => {
						if (item.value) {
							this.$emit('change', this.designsObj[item.id], item.value)
							return false
						}
					})
					let arr = this.checkArr.filter(item => item.value)
					if (!arr.length) this.$emit('save')
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		backList () {
			this.$router.push('/qc/scheme')
		},
		update (item) {
			this.checkArr.push(item)
		}
	}
}
</script>
<style lang="scss" scoped>
.setting-box {
	min-height: 812px;
	.card {
		height: 100%;
	}
}
.setting-header {
	height: 40px;
	line-height: 40px;
}
.headder {
	padding-bottom: 24px;
	border-bottom: 0.5px solid #e5e5e5;
	justify-content: space-between;
}
.empty {
	text-align: center;
	font-size: 12px;
	margin-top: 150px;
	color: #324057;
}
.empty img {
	margin: auto;
	display: block;
}
.empty p {
	margin-top: 2em;
}
.pl-120 {
	padding-left: 100px;
}
.pr-120 {
	padding-right: 100px;
}
</style>
